module.exports = flarum.core.compat['components/Search'];